import { useState, useEffect, useCallback, useRef } from 'react';

// Végtelen görgetés hook üzenet listákhoz
export function useInfiniteScroll(loadMore, hasMore = true, threshold = 100) {
  const [loading, setLoading] = useState(false);
  const observerRef = useRef(null);
  const loadingRef = useRef(false);

  // Betöltés indítása
  const handleLoadMore = useCallback(async () => {
    if (loadingRef.current || !hasMore) return;

    try {
      loadingRef.current = true;
      setLoading(true);
      await loadMore();
    } catch (error) {
      console.error('Infinite scroll hiba:', error);
    } finally {
      setLoading(false);
      loadingRef.current = false;
    }
  }, [loadMore, hasMore]);

  // Intersection Observer beállítása
  const setObserverTarget = useCallback((element) => {
    if (observerRef.current) {
      observerRef.current.disconnect();
    }

    if (!element || !hasMore) return;

    observerRef.current = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && !loadingRef.current) {
          handleLoadMore();
        }
      },
      {
        rootMargin: `${threshold}px`,
        threshold: 0.1
      }
    );

    observerRef.current.observe(element);
  }, [handleLoadMore, hasMore, threshold]);

  // Cleanup
  useEffect(() => {
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return {
    loading,
    setObserverTarget
  };
}

export default useInfiniteScroll;
